module.exports = __webpack_public_path__ + "assets/005a2e468579e5563d265aada2648535.png";